// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_bzDUkY","outset":"ob_znWwx1","arrow":"ob_CRUkL2","arrow_left":"ob_W8hNYE","arrow_right":"ob_WdBX8X","disabled":"ob_GwxxEt"};